export const ZITADEL_ROLE_FREELANCER = "FREELANCER";
export const ZITADEL_ROLE_EMPLOYEE = "EMPLOYEE";
export const ZITADEL_ROLE_CLIENT = "CLIENT";

export const CLIENT_ADMIN = "CLIENT_ADMIN";
export const CLIENT_PROJECT_MANAGER = "CLIENT_PROJECT_MANAGER";
export const CLIENT_VIEWER = "CLIENT_VIEWER";
